import * as React from "react";

var Header = function Header(props) {
  var poliza = props.poliza;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fuid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "modal-title",
    id: "exampleModalLabel"
  }, "Propuesta: ", poliza === null || poliza === void 0 ? void 0 : poliza.id, " ", poliza !== null && poliza !== void 0 && poliza.code ? "- N\xBA p\xF3liza: ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code) : "")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 float-right"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"))));
};

export default Header;